import { Directive, Host, OnInit } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';

/**
 * Fallback for datepickers missing explicit template attrs (signal `appendTo` ignores host bindings).
 * All templates should set `[showButtonBar]="true" appendTo="body"`; see providePrimeNG overlayAppendTo.
 */
@Directive({
  selector: 'p-datepicker:not([showButtonBar])',
  standalone: true
})
export class XiroccoDatepickerButtonBarDirective implements OnInit {
  constructor(@Host() private readonly datepicker: DatePicker) {}

  ngOnInit(): void {
    this.datepicker.showButtonBar = true;
  }
}
